import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import ItemData from '../Model/items.json'

function ProductCard({ image, title }) {
  return (
    <div className="w-full max-w-xs bg-white border border-gray-200 shadow md:max-w-sm">
      <a href="#">
        
        <img className="p-8 rounded-t-lg" src={image} alt="product image" />
        
      </a>
      <div className="px-5 pb-5">
        <a href="#">
          <h5 className="text-xl font-semibold tracking-tight text-gray-900 ">{title}</h5>
        </a>
      </div>
    </div>
  );
}

function Showcase() {
  const products = ItemData.products;
 

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  

  return (
    
    <div className=" hidden md:block bg-no-repeat bg-cover bg-[#04347c] py-8">
      <div className="container px-4 mx-auto">
        <div className="py-4 mb-4 text-4xl font-bold leading-none tracking-tight text-center text-white md:text-5xl lg:text-6xl">
          Our Products
        </div>
        <Slider {...settings}>
          {products.map((product, index) => (
            <div className="px-4" key={index}>
              <div className="px-20 py-2 md:px-2">
                <ProductCard {...product} />
              </div>
            </div>
          ))}
        </Slider>
        <a href="/Items">
          <div className="w-64 py-6 mx-auto mt-8 mb-4 text-xl font-bold leading-none tracking-tight text-center text-black bg-white rounded">
            View All Products
          </div>
        </a>
      </div>
    </div>
  );
}

export default Showcase;
